export const SET_DATA_PRODUCTS_SCROLL = 'SET_DATA_PRODUCTS_SCROLL'
export const SET_DATA_PRODUCTS_SCROLL_RESET = 'SET_DATA_PRODUCTS_SCROLL_RESET'

export const InitialState: ScrollProductsState = {
  dataProducts: null,
}

export interface ScrollProductsState {
  dataProducts: DataProductsScroll | null
}

export interface DataProductsScroll {
  index: number
  length: number
  first: number
  end: number
}

export interface SetDataProductsScroll {
  type: typeof SET_DATA_PRODUCTS_SCROLL
  payload: DataProductsScroll
}

export interface SetDataProductsScrollReset {
  type: typeof SET_DATA_PRODUCTS_SCROLL_RESET
  payload: null
}

export type ScrollProductsActions = SetDataProductsScroll | SetDataProductsScrollReset
